<template>
    <Chart :options="chartOptions" />
</template>

<script>
import { Chart } from 'highcharts-vue';

export default {
    props: {
        width: {
            type: Number,
            default: 120,
        },
        height: {
            type: Number,
            default: 20,
        },
        data: null,
        reverseYAxis: Boolean,
        xAxisType: null,
        seriesName: null,
    },
    components: {
        Chart,
    },
    computed: {
        chartOptions() {
            // Adapted from Highcharts sparkline demo
            return {
                chart: {
                    backgroundColor: null,
                    borderWidth: 0,
                    type: 'line',
                    margin: [2, 0, 2, 0],
                    width: this.width,
                    height: this.height,
                    style: {
                        overflow: 'visible'
                    },

                    // small optimalization, saves 1-2 ms each sparkline
                    skipClone: true
                },
                title: {
                    text: ''
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: [],
                    visible: false,
                    type: this.xAxisType,
                },
                yAxis: {
                    reversed: this.reverseYAxis,
                    endOnTick: false,
                    startOnTick: false,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    tickPositions: []
                },
                legend: {
                    enabled: false
                },
                tooltip: {
                    hideDelay: 0,
                    outside: true,
                    shared: true
                },
                plotOptions: {
                    series: {
                        animation: false,
                        lineWidth: 2,
                        shadow: false,
                        states: {
                            hover: {
                                lineWidth: 3,
                            },
                        },
                        marker: {
                            radius: 0,
                            states: {
                                hover: {
                                    radius: 1
                                }
                            }
                        },
                        fillOpacity: 0.25
                    },
                    column: {
                        negativeColor: '#910000',
                        borderColor: 'silver'
                    }
                },
                series: [
                    {
                        name: this.seriesName,
                        data: this.data,
                        color: '#0f6ebf',
                        clip: false,
                    },
                ],
            };
        }
    },
}
</script>
